<template>
  <div class="orc-vert-limit-header py-12 pb-16">
    <h1 class="text-2xl mb-6"><i class="el-icon-medal mr-3"></i>Disciplines</h1>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="8" :lg="8" v-for="branch in nonPseudoBranches" :key="branch.id">
        <el-card shadow="hover" class="orc-wave-blue mb-5 pb-20 card h-full">
            <div slot="header" class="clearfix cursor-pointer" @click="changeBranch(branch.id)">
              <el-tooltip class="item" effect="dark" content="Klik voor meer info." placement="top">
                <div class="inline">
                  {{ branch.name }}
                  <i class="el-icon-right ml-2"></i>
                </div>
              </el-tooltip>
            </div>

          <div>
            <content-displayer :current="branch.shortDescription"></content-displayer>
          </div>

          <div class="absolute bottom-0 left-0 right-0 w-full">
            <el-tooltip class="item" effect="dark" content="Inschrijvingen voor deze tak zijn uitgeschakeld."
                        placement="top" :disabled="branch.isActive">
              <div class="flex justify-center m-4 mb-8 mt-6">
                <el-button class="self-center" type="primary" @click="enroll(branch.id)" :disabled="!branch.isActive">
                  Inschrijven<i class="ml-2 el-icon-plus"></i></el-button>
              </div>
            </el-tooltip>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import ContentDisplayer from "../content/ContentDisplayer";

  export default {
    name: "Branches",
    props: ["branchOptions"],
    components: {ContentDisplayer},
    data() {
      return {
        activeName: '1',
        branches: this.getBranches(),
      }
    },
    methods: {
      getBranches() {
        this.$http.get(`branches/overview`).then((response) => {
          this.branches = response.data
        }).catch(function (error) {
          console.log(error)
        })
      },
      enroll(branchId) {
        this.$parent.showEnrollmentDialog(branchId);
      },
      changeBranch(branchId) {
        this.$parent.changeBranch(branchId)
      }
    },
    computed: {
      nonPseudoBranches() {
        if (this.branches) {
          return this.branches.filter(e => {
            return !e.isPseudo
          })
        } else {
          return []
        }
      }
    }
  }
</script>

<style scoped>
  .card {
    min-height: 400px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/branches/Branches.vue